import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const Title = styled.h2`
  font-size: 3rem;
  text-align: center;
  color: #18216d;
  margin-bottom: 60px;
  font-weight: 700;
`;

export const Section = styled.div`
  margin-bottom: 60px;
  padding: 30px;
  border-radius: 12px;
  background-color: #f9fafb;
  box-shadow: 0 4px 12px rgba(0,0,0,0.04);
`;

export const IndustriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  margin-top: 30px;
  justify-content: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const IndustryCard = styled.div`
  background-color: #f9fafb;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0,0,0,0.04);
  transition: transform 0.3s ease, border-color 0.3s ease;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-6px);
    border-color: #3182ce;
  }
`;

export const IndustryName = styled.p`
  font-weight: 600;
  font-size: 1.3rem;
  margin: 0;
  color: inherit;
`;

export const IndustryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;

  svg {
    font-size: 1.5rem;
    color: #3182ce;
    margin-right: 10px;
  }
`;

export const IndustryExample = styled.p`
  margin-top: 8px;
  font-size: 0.95rem;
  color: #718096;
  opacity: 0;
  transition: opacity 0.3s ease;

  ${IndustryCard}:hover & {
    opacity: 1;
  }
`;
